export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-trophy-c1f9e3de7fdc776c7f10898ae3dce92f.svg";